module.exports = __webpack_public_path__ + "bundle/fonts/CutiveMono-Regular.ttf";